<div class="builder-page-container">
  <div *ngIf="loading" class="loading-spinner">
    <p>Loading...</p>
  </div>

  <div *ngIf="error && !loading" class="error-message">
    <h2>{{ error }}</h2>
    <p>Please make sure you have created content in Builder.io for this page.</p>
  </div>

  <builder-content
    *ngIf="content && !loading"
    [model]="'page'"
    [content]="content"
    [apiKey]="apiKey"
    [customComponents]="customComponents">
  </builder-content>
</div>

